
import { useResizeScreen } from "../../hooks/useResizeScreen";
import ModalRegisterProfileMedico from "../DialogRegisterProfile/ModalRegisterProfileMedico";

const ModalProfileMedico = ({ isOpen, setOpen }) => {

    const { screen } = useResizeScreen();

    return <>
    { isOpen ?
        <ModalRegisterProfileMedico
            style={{margin:"center"}}
            title={
                <div style={{ marginTop:  screen.sWidth < 768 ? "0px" :'20px', fontSize:"19px" }}>
                    No se encuentra registrado como Afiliado
                </div>
            }            description={
                <div style={{ textAlign: 'center',marginBottom:"40px", marginTop:"-15px" }}>
                    ¿Desea registrarse?
                </div>
            }
            open={isOpen}
            onClose={setOpen}
            modalconfirm={true}
            modalLogout={true}
            
        />
        : ""}
</>;
};

export default ModalProfileMedico;